import {
    Table,
    TableRow,
    TableCell,
    Paragraph,
    TextRun,
    WidthType,
} from "docx";

import { formatCurrency } from "../../../pages/organization/project/tab-costs/utils";

type TGenerateActivityProfileTable = {
    tableData: string[][];
    totalEstimatedHours: number;
    totalValue: number;
};

/**
 * Generates an activity profile table for DOCX documents
 */
export const generateActivityProfileTable = ({
    tableData,
    totalEstimatedHours,
    totalValue,
}: TGenerateActivityProfileTable): Table => {
    const activityTable = new Table({
        width: { size: 100, type: WidthType.PERCENTAGE },
        rows: [
            // Cabeçalho
            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({ text: "Função", bold: true }),
                                ],
                            }),
                        ],
                        columnSpan: 2,
                        width: { size: 10, type: WidthType.PERCENTAGE },
                    }),
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: "% Cálculo",
                                        bold: true,
                                    }),
                                ],
                            }),
                        ],
                        width: { size: 8, type: WidthType.PERCENTAGE },
                    }),
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: "Cálculo de Perfis",
                                        bold: true,
                                    }),
                                ],
                            }),
                        ],
                        columnSpan: 2,
                        width: { size: 15, type: WidthType.PERCENTAGE },
                    }),
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: "Custo Hora",
                                        bold: true,
                                    }),
                                ],
                            }),
                        ],
                        columnSpan: 2,
                        width: { size: 10, type: WidthType.PERCENTAGE },
                    }),
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: "Horas Estimadas",
                                        bold: true,
                                    }),
                                ],
                            }),
                        ],
                        width: { size: 10, type: WidthType.PERCENTAGE },
                    }),
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: "Valor Total",
                                        bold: true,
                                    }),
                                ],
                            }),
                        ],
                        width: { size: 10, type: WidthType.PERCENTAGE },
                    }),
                ],
            }),

            // Dados da tabela
            ...tableData.map(
                (row) =>
                    new TableRow({
                        children: [
                            new TableCell({
                                columnSpan: 2,
                                children: [new Paragraph(row[0])],
                            }),
                            new TableCell({
                                columnSpan: 2,
                                children: [new Paragraph(row[1])],
                            }),
                            new TableCell({
                                columnSpan: 2,
                                children: [new Paragraph(row[2])],
                            }),
                            new TableCell({
                                children: [new Paragraph(row[3])],
                            }),
                            new TableCell({
                                children: [new Paragraph(row[4])],
                            }),
                            new TableCell({
                                children: [new Paragraph(row[5])],
                            }),
                        ],
                    })
            ),

            // Linha de totais
            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({ text: "Total", bold: true }),
                                ],
                            }),
                        ],
                        columnSpan: 6,
                    }),
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({ text: "-", bold: true }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: `${totalEstimatedHours}`,
                                        bold: true,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: `${formatCurrency(
                                            String(totalValue)
                                        )}`,
                                        bold: true,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    return activityTable;
};
